export class VehicleService {
    private vinLookupBaseApi = process.env.REACT_APP_BASE_API_URL;
    
    public getYears() {
        var currentYear = new Date().getFullYear() + 1;
        var years = [];
        var startYear = 1980;  
        
        while ( startYear <= currentYear ) {
            years.push(startYear++);
        }   

        return years.reverse();
    }

    public getMakes(state: string, year: number){
        let vehicleMakesApi = (this.vinLookupBaseApi ?? "") + process.env.REACT_APP_API_LOOKUP_VEHICLE_MAKE?.replace("{state}", state)
        .replace("{year}", year.toString());

        return fetch((vehicleMakesApi ?? ""),
            {
                mode: "cors",
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "pace-api-key": (process.env.REACT_APP_API_KEY ?? "")
                }
            });
    }

    public getModels(state: string, year: number, make: string){
        let modelsEndpoint = process.env.REACT_APP_API_LOOKUP_VEHICLE_MODEL;
        let api = (this.vinLookupBaseApi ?? "") + modelsEndpoint?.replace("{state}", state)
        .replace("{year}", year.toString())
        .replace("{make}", make);

        return fetch((api ?? ""),
            {
                mode: "cors",
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "pace-api-key": (process.env.REACT_APP_API_KEY ?? "")
                }
            });
    }

    public getStyles(year: number, make: string){

    }

    public getDefaultVin(year: number, make: string, model: string){

    }

    public getVehicleByVin(state: string, vin: string){
        let modelsEndpoint = process.env.REACT_APP_API_LOOKUP_VEHICLE_BY_VIN;
        
        let api = (this.vinLookupBaseApi ?? "") + modelsEndpoint?.replace("{state}", state)
        .replace("{vin}", vin);
        

        return fetch((api ?? ""),
            {
                mode: "cors",
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "pace-api-key": (process.env.REACT_APP_API_KEY ?? "")
                }
            });
    }
}